module.exports = __webpack_public_path__ + "static/media/logo.521e33af.png";